import { legislativeItemSystemStatusValueLabels } from './value-labels.js';
export const legislativeItemsCube = {
    category: 'Legislation',
    description: 'Legislative items with type, status, department, and staff contact details.',
    label: 'Legislative Items',
    requiredModule: 'hasAgenda',
    measures: {
        'legislative_items.count': { label: 'Count', type: 'number' },
        'legislative_items.distinct_departments': { label: 'Distinct Departments', type: 'number' },
        'legislative_items.distinct_types': { label: 'Distinct Types', type: 'number' },
        'legislative_items.emergency_count': { label: 'Emergency Requests', type: 'number' },
    },
    dimensions: {
        'departments.name': { label: 'Department', type: 'string' },
        'legislative_items.code': { label: 'Number', type: 'string' },
        'legislative_items.executive_session': { label: 'Executive Session', type: 'boolean' },
        'legislative_items.full_title': { label: 'Title', type: 'string' },
        'legislative_items.public_hearing': { label: 'Public Hearing', type: 'boolean' },
        'legislative_items.requesting_consent': { label: 'Consent Agenda', type: 'boolean' },
        'legislative_items.requesting_emergency': { label: 'Emergency Request', type: 'boolean' },
        'legislative_items.short_title': { label: 'Short Title', type: 'string' },
        'legislative_items.status': {
            label: 'System Status',
            type: 'string',
            valueLabels: legislativeItemSystemStatusValueLabels,
        },
        'legislative_items.summary': { label: 'Summary', narrative: true, type: 'string' },
        'legislative_statuses.name': { label: 'Public Meeting Status', type: 'string' },
        'legislative_types.name': { label: 'Item Type', type: 'string' },
        'meeting_bodies.name': { label: 'Meeting Body', type: 'string' },
        'users.display_name': { label: 'Staff Contact', type: 'string' },
    },
    timeDimensions: {
        'legislative_items.created_at': { label: 'Created At', type: 'date' },
        'legislative_items.target_meeting_date': { label: 'Target Meeting Date', type: 'date' },
        'legislative_items.updated_at': { label: 'Updated At', type: 'date' },
    },
};
